// extracted by mini-css-extract-plugin
export default {"subtitle":"ServicesText_subtitle__qG-2z","title":"ServicesText_title__vIlTN","flashlight__wrapper":"ServicesText_flashlight__wrapper__rjGXG"};